import {useEffect} from 'react'
import {addRecentApp} from 'helpers/localStorage'
import {PATHNAME_TO_RECENT_APP_ID} from './recentAppsConfig'
import {RECENT_APPS_CHANGED_EVENT} from './useRecentApps'

// Ghi nhận "vào app" cho 10 mục Kristo Apps (Edu/Family/Missals/Hymns/Library/Games/Discussions/
// Mass Times/Directory/Prayers) - CHỈ localStorage theo máy/trình duyệt (đã chốt với user, không
// đụng backend) để hiển thị lại làm shortcut "dùng gần nhất". Mount 1 lần ở root router
// (routes/createRoutes.js), cùng vị trí + cách khớp theo pathname với PageViewTracker
// (components/PageViewTracker.js) - không tạo cơ chế lắng nghe route riêng.
const RecentAppsTracker = ({value}) => {
    useEffect(() => {
        const appId = PATHNAME_TO_RECENT_APP_ID[value]
        if (appId) {
            addRecentApp(appId)
            window.dispatchEvent(new Event(RECENT_APPS_CHANGED_EVENT))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    return null
}
export default RecentAppsTracker
